import Vue from 'vue';
import Vuex from 'vuex';
import counter from '@/store/modules/Counter';
import auth from '@/store/modules/Auth';
import report from '@/store/modules/Report';
import account from '@/store/modules/Account';
import profile from '@/store/modules/Profile';
import balance from '@/store/modules/Balance';
import general from '@/store/modules/General';
import game from '@/store/modules/Game';
import statement from '@/store/modules/Statement';
import suggest from '@/store/modules/Suggest';
import dashboard from '@/store/modules/Dashboard';
import announcement from '@/store/modules/Announcement';
import agentbanner from '@/store/modules/AgentBanner';
import apikey from '@/store/modules/ApiKey';
import bankaccount from '@/store/modules/BankAccount';
import multicurrency from '@/store/modules/Currency';
import document from '@/store/modules/Document';
import round from '@/store/modules/Round';
import secure from '@/store/modules/SecureCode';
import resetlog from '@/store/modules/ResetPasswordLog';
import activity from '@/store/modules/Activity';
import marketing from '@/store/modules/Marketing';
import cryptoaccount from '@/store/modules/CryptoAccount';
import commissionlog from '@/store/modules/CommissionLog';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    counter,
    auth,
    report,
    account,
    profile,
    balance,
    general,
    game,
    statement,
    suggest,
    dashboard,
    announcement,
    agentbanner,
    apikey,
    bankaccount,
    multicurrency,
    document,
    round,
    secure,
    resetlog,
    activity,
    marketing,
    cryptoaccount,
    commissionlog,
  },
});
